module.exports = __webpack_public_path__ + "img/Transpordiamet_logo_must_eng.aad88a19.svg";